import { useClientSmallScreen } from '@/lib/user-agent/client';

import Section from '@/components/app/product/components/@shared/section';
import FAQ from '@/components/shared/components/faq';

import FaqModel from '@/models/faq.model';
import { DATA_CY_PRODUCT_FAQ } from '@/constant/cypress';

export default function ProductFAQ({ faq, ...props }: { faq: FaqModel[] }) {
  const isSmallScreen = useClientSmallScreen();

  return (
    <Section
      data-cy={DATA_CY_PRODUCT_FAQ}
      className='mx-0!'
      id='faqSection'
      expandable={isSmallScreen}
      {...props}
    >
      <FAQ faqList={faq} />
    </Section>
  );
}
